module.exports = __webpack_public_path__ + "img/bag-tag.4e168b4d.jpg";